import Decimal from 'decimal.js';
import {divideMoney} from './purchase-workspace.mjs';

export function quantityDetailsPatch(line,rows) {
  if(!rows.length || rows.length>100) throw Error('Isi 1 sampai 100 baris rincian QTT.');
  const units=[{name:line.baseUnit,pieces:1},...(line.units||[])];
  const details=rows.map(row=>{
    const unit=units.find(u=>u.name===row.unit),qty=Number(row.qty);
    if(!unit || !Number.isSafeInteger(qty) || qty<=0 || qty>1000000) throw Error('Isi QTT bulat lebih dari 0 dan pilih satuan terdaftar.');
    if(row.total==='' || row.total==null) throw Error('Isi total harga setiap baris, termasuk 0 bila memang gratis.');
    let total;try{total=new Decimal(row.total);}catch{throw Error('Total harga tidak valid.');}
    if(!total.isFinite() || total.isNegative() || total.decimalPlaces()>2 || total.gt('100000000000000000')) throw Error('Total harga harus positif atau 0, maksimal dua angka desimal.');
    return {qty,unit:unit.name,pieces:Number(unit.pieces),total:total.toFixed()};
  });
  const stock=details.reduce((n,r)=>n+r.qty*r.pieces,0);
  if(!Number.isSafeInteger(stock)||stock<=0)throw Error('Total QTT tidak valid.');
  const pieces=stock%Number(line.pieces)===0?Number(line.pieces):1,qty=stock/pieces;
  if(qty>1000000)throw Error('QTT beli melebihi batas 1 juta.');
  const subtotal=details.reduce((n,r)=>n.plus(r.total),new Decimal(0)).toFixed();
  const cost=divideMoney(subtotal,qty);
  return {quantity_details:details,variant_quantities:[],qty,pieces,unit:pieces===Number(line.pieces)?line.unit:line.baseUnit,
    inputMode:'subtotal',subtotal,cost,baseCost:divideMoney(cost,pieces)};
}
